function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "h5sqdd5yqa",
  x1: "14.646%",
  x2: "55.417%",
  y1: ".504%",
  y2: "73.101%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".04%",
  stopColor: "#4AC9E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#56FDD2"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.198
}, /*#__PURE__*/React.createElement("g", {
  fill: "url(#h5sqdd5yqa)",
  transform: "translate(-1381 -708)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1665.302 1220.618c99.512 8.783 152.382-45.172 207.623-276.476 55.24-231.305-238.346-321.046-351.318-216.12-112.973 104.927-75.455 156.146-94.284 271.188-18.828 115.041 138.466 212.624 237.979 221.408z",
  transform: "rotate(113 1652.776 953.004)"
})));

var SvgIconOvalRight1 = function SvgIconOvalRight1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 495,
    viewBox: "0 0 307 495",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOvalRight1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-oval-right-1.3952716b.svg";
export { ForwardRef as ReactComponent };